module.exports = __webpack_public_path__ + "static/media/pasticceria_7.c18f30cc.jpg";